// Domain-based branding configuration

export const IS_NETCONSOLE = typeof window !== 'undefined'
  && window.location.hostname.includes('netconsole.cloud');

export const BRAND = {
  name: IS_NETCONSOLE ? 'NetConsole' : 'Cloud UniFi',
  shortName: IS_NETCONSOLE ? 'NetConsole' : 'Cloud UniFi',
  domain: IS_NETCONSOLE ? 'netconsole.cloud' : 'cloudunifi.com',
  loginUrl: IS_NETCONSOLE
    ? 'https://login.netconsole.cloud'
    : (import.meta.env.VITE_LOGIN_URL || 'https://login.cloudunifi.com'),
  portalUrl: IS_NETCONSOLE
    ? 'https://portal.netconsole.cloud'
    : 'https://portal.cloudunifi.com',
  helpUrl: 'https://help.cloudunifi.com', // Shared help center
  supportEmail: 'support@cloudunifi.com', // Shared support
  termsUrl: IS_NETCONSOLE
    ? 'https://netconsole.cloud/terms/'
    : 'https://help.cloudunifi.com/terms/',
  privacyUrl: 'https://help.cloudunifi.com/privacy/', // Shared privacy policy
};

// Update document title based on brand
export function updateDocumentTitle(pageTitle?: string) {
  if (pageTitle) {
    document.title = `${pageTitle} - ${BRAND.name}`;
  } else {
    document.title = `${BRAND.name} Portal`;
  }
}

// Initialize brand on page load
if (typeof window !== 'undefined') {
  updateDocumentTitle();
}
